






















import Vue from 'vue';
import ReferenceX1 from '@/components/ReferenceX1.vue';

export default Vue.extend({
    name: 'play',
    components: { ReferenceX1 },
});
